import { render, staticRenderFns } from "./perceptionResult.vue?vue&type=template&id=2f7776aa&scoped=true&"
import script from "./perceptionResult.vue?vue&type=script&lang=js&"
export * from "./perceptionResult.vue?vue&type=script&lang=js&"
import style0 from "./perceptionResult.vue?vue&type=style&index=0&id=2f7776aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7776aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
